import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
	ApiError,
	InteractionTypeListParams,
	InteractionTypeListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<
	UseQueryOptions<InteractionTypeListResponse, ApiError>,
	'queryKey' | 'queryFn'
>;

export const fetchInteractionTypeList = async (
	params: InteractionTypeListParams
): Promise<InteractionTypeListResponse> => {
	const url = apiEndpoints.interactionTypes.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useInteractionTypeList = (params: InteractionTypeListParams, options?: QueryOptions) => {
	return useQuery<InteractionTypeListResponse, ApiError>({
		queryKey: ['interaction', 'list', params],
		queryFn: () => fetchInteractionTypeList(params),
		...options,
	});
};

export default useInteractionTypeList;
